module.exports = __webpack_public_path__ + "static/media/VRED Professional.46ed6167.png";